export default "__VITE_ASSET__4qYAwJJI__"